export default {
	policyNo: 'Zadejte celé číslo PS, tj. 9-10 číslic.',
	policyFrameworkNo: 'Zadejte celé číslo RS tj. minimálně 8 číslic.',
	agencyNumber: 'Zadejte 3-8 číslic',
	sellerIn: 'Zadejte celé získatelské číslo tj. 9 číslic',
	birthNumber: 'Zadejte rodné číslo (9-10 znaků)',
	taxNumber: 'Zadejte 8 číslic',
	phone: 'Zadejte hodnotu telefonu v tuzemském formátu (9 znaků) nebo v mezinárodním (+1, 001, +420, 00420)',
	postalCode: 'Zadejte číslo PSČ bez mezery ve formátu např. 00000.',
	proposalNo: 'Zadejte 7 až 20 číslic, text nebo znaky: - . / \\.',
	email: 'Zadejte e-mailovou adresu ve formátu „klient@domena.cz“.',
	ppProduct: 'Zadejte částku o maximální velikosti 99 999 999 a maximálně se dvěma desetinnými čísly.',
	sellerInRange: 'Zadejte 3-9 číslic',
	claimNoCP: 'Zadejte 4 až 20 znaků. Můžete zadat číslice, malá a velká písmena bez diakritiky nebo znaky : - . / .',
	semaphoreCurrentStatus: 'Data v grafu jsou aktualizována na týdenní bázi.',
	semaphoreImpendingState:
		'Jedná se o klienty, u kterých hrozí přesun do nižšího barevného segmentu, pokud u nich nedojde k definovanému kontaktu (vstupujícího do nápočtu Semaforu). Data v grafu jsou aktualizována na týdenní bázi.',
	carRegNo: 'Zadejte registrační značku',
	uploadDocumentAttachment: 'Pro přiložení dokumentu k úkolu prosím klikněte na ikonu na konci řádku.',
	activePolicyWoQuotationOnly: 'Jedná se o aktivní smlouvy včetně předsmluv.',
	printNotAllowed: 'Vypršel čas pro nastavení tisku kampaně nebo není tisk povolen.',
	graphDataRefreshedEveryHour: 'Data v grafu se aktualizují jednou za hodinu.',
	ppzCampaignsIncluded: 'V datech jsou zahrnuty i kampaně vašich podobchodníků.',
};
